import React, {  useState, useEffect } from 'react'
import '../App.css';
import BikeRobery from '../components/BikeRobery'
import FormBikes from '../components/FormBikes'
import {bikeI} from '../interfaces/bikes'
import 'bootstrap/dist/css/bootstrap.css';
import { useParams } from 'react-router-dom';
import Logo from '../logo.svg';

function Home() {
  let [bikes, setBikes] = useState<Array<bikeI>>([])
  let [load, setLoad] = useState<Boolean>(false)
  let { page } = useParams();

  const handleCurrentBikes = (currentBikes: bikeI[]): void => {
    setBikes(currentBikes)
  }
  //init page
  useEffect(() => {
    setLoad(true)
  }, [])

  return (
    <div className="App">
      <header className="App-header">
        <img src={Logo} alt="logo" width={50} height={50}/>
        <title>Police Departament of Berlin - Stolen Bike</title>
        <p className="description">Stolen Bikes</p>
      </header>

      <main className='content'>
        <section className="py-5 container">
          <div className="container">
            <FormBikes onSearchBike={handleCurrentBikes} pageParam={page} loadNow={load}/>
          </div>

          <div className="row">
            <BikeRobery bikes={bikes} />
          </div>
        </section>

      </main>
    </div>
  )
}

export default Home;
